export default __webpack_public_path__ + "locales/az/Webhooks.json?hash=61a992dd0d6cedc17db913c524b4d548";